module.exports = __webpack_public_path__ + "static/media/masterCardIcon.93135c91.svg";